import styled from "styled-components";
import { V3Caption } from "../Typography";

export const V3CaptionGrey35 = styled(V3Caption)`
    color: ${({ theme }) => theme.v3.colors.grey35};
`;